export default "__VITE_ASSET__WRyd867B__"